import { css } from "@emotion/css";
import { fontWeight, themeTokens } from "@octopusdeploy/design-system-tokens";
import * as React from "react";
import type { HelpPanelImage } from "~/components/OnboardingDialog/HelpPanel";
import helpImageSvg from "../../assets/process-template-parameter-help.svg";
const helpStyles = {
    content: css({
        marginTop: 0,
        h3: { marginTop: 0, fontWeight: fontWeight["700"], color: themeTokens.color.dialog.helpPanel.text },
        p: { color: themeTokens.color.dialog.helpPanel.text },
    }),
};
export const ParameterConfigurationHelpContent = (<span className={helpStyles.content}>
        <h3>Add Parameter</h3>
        <p>Parameters let consumers of this template provide values specific to their projects.</p>
    </span>);
export const ParameterConfigurationHelpImage: HelpPanelImage = {
    altText: "Add Parameter Help",
    src: helpImageSvg,
};
export const ParameterDefaultValueHelpContent = (<span className={helpStyles.content}>
        <h3>Default Values</h3>
        <p>Specify default values that will be pre-populated when projects use this parameter.</p>
        <p>Default values can be scoped to specific environments when needed.</p>
    </span>);
export const ParameterDefaultValueHelpImage: HelpPanelImage = {
    altText: "Parameter Default Values Help",
    src: helpImageSvg,
};
